let isActive = false

export const setResourceEmailConflictToastActive = (value: boolean): void => {
  isActive = value
}

export const isResourceEmailConflictToastActive = (): boolean => isActive
